// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const Svg3DshareTv24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path d="M12 20V18.5H20C20.2761 18.5 20.5 18.2761 20.5 18V6C20.5 5.72386 20.2761 5.5 20 5.5H4C3.72386 5.5 3.5 5.72386 3.5 6V11H2V6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H12Z" />
				<path d="M5.64564 12.8256L7.83136 13.7599L7.46279 13.8542C6.74279 14.0342 5.67136 14.4114 4.67707 15.1571C3.63136 15.9456 2.36279 17.3856 2.28564 19.7771V19.8628H3.71707V19.7771C3.77707 18.3285 4.38564 17.1628 5.53422 16.2971C6.51136 15.5685 7.59993 15.2685 8.16565 15.1571L8.40564 15.1056L7.45422 17.3256L8.76565 17.8914L10.6514 13.4942L10.6856 13.4171L6.21136 11.4971L5.64564 12.8085V12.8256Z" />
			</Svg>
		);
	}
);
Svg3DshareTv24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default Svg3DshareTv24;
